"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useHandleDimentions = () => {
  const [height, setHeight] = (0, _react.useState)(0);
  const [width, setWidth] = (0, _react.useState)(0);
  const dimentionsRef = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(() => {
    const rect = dimentionsRef.current?.getBoundingClientRect();
    setHeight(rect?.height || 0);
    setWidth(rect?.width || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimentionsRef.current]);
  return {
    height,
    width,
    dimentionsRef
  };
};
var _default = exports.default = useHandleDimentions;